import { FormLayout, Spacing } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { useCreateOrEditRulesetModal } from '../../context/createOrEditRulesetModalContext'

interface ModalContentProps {
  children?: ReactNode
}

export const modalContentLayout: FormLayout = {
  columnSpacing: Spacing.S40,
  rowSpacing: Spacing.S16,
  spacing: Spacing.S16,
  itemsInRow: 2,
}

export const ModalContent = ({ children }: ModalContentProps): ReactElement => {
  const { Form } = useCreateOrEditRulesetModal()

  return <Form layout={modalContentLayout}>{children}</Form>
}
